import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserInfo } from '../../userInfo';
import { error } from 'selenium-webdriver';
import { Languges } from '../../Languages';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { catchError, map, share } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { ModalService } from '../../reactive-forms/components/_modal';
import { SharedHandlersService } from '../shared-handlers.service';
import { ToastrService } from 'ngx-toastr';
import { SharedURLsData } from '../.././model/SharedURLsData';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';



@Injectable({
  providedIn: 'root'
})

export class SBHttpServicesService extends BehaviorSubject<GridDataResult>{
  //dictionary used to cached request using key= url and value= request data
  private Dic = new Map<string, SharedURLsData>();
  constructor(public http: HttpClient, public lang: Languges, public modalService: ModalService
    , public translate: TranslateService,
    public toastr: ToastrService) {
    super(null);
  }

  public queryGrid(url: string, httpClient: HttpClient): void {
    var accessToken = UserInfo.AccessToken;
    var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
    httpClient
      .get(url, { headers: headers })
      .pipe(
        map(response => (<GridDataResult>{
          data: response["data"],
          total: parseInt(response["TotalCount"], 10)
        })),
        catchError(err => {
          return throwError(err);
        })
      ).subscribe(x => {
        super.next(x),
          err => this.ErrorPerStatus(err)
      });
  }

  public async GetData(url: string, httpClient?: HttpClient, errorCallBackFunc = '') {
    var accessToken = UserInfo.AccessToken;
    var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
    var ApiResponse = await httpClient
      .get(url, { headers: headers });
    this.RequestsessionTimeOut(ApiResponse);
    return ApiResponse;

  }
  public async GetOData(url: string, httpClient?: HttpClient, errorCallBackFunc = '', showLoader = true) {
    var accessToken = localStorage.getItem('ODataToken');
    var headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${accessToken}`);
    if (showLoader == false) {
      headers = headers.set('ShowLoader', 'false');
    }

    var ApiResponse = await this.http
      .get(url, { headers: headers });
    this.RequestsessionTimeOut(ApiResponse);
    return ApiResponse;

  }

  RequestsessionTimeOut<T>(ApiObserver: Observable<T>) {
    //ApiObserver.pipe(
    //  catchError(err => {
    //    return throwError(err);
    //  })
    //).subscribe(
    //  res => console.log('HTTP response', res),
    //  err => this.ErrorPerStatus(err),
    //  () => console.log('HTTP request completed.')
    //);

  }
  ErrorPerStatus(err) {
    if (err.status == 401)
      this.sessionTimeOut();
    else
      this.errorHandle(err);
  }
  sessionTimeOut() {
    localStorage.removeItem("jwt");
    sessionStorage.clear();
    localStorage.removeItem("userinfo");
    window.location.href = '/';
  }


  public async httpGetRequest(url, errorCallBackFunc = '', showLoader = true) {
    var accessToken = UserInfo.AccessToken;
    var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
    if (showLoader == false) {
      headers = headers.set('ShowLoader', 'false');
    }
    var getResult;
    var ApIRequest = this.http.get(url, { headers: headers });
    await ApIRequest.toPromise().then((result) => {
      getResult = result;
    },
      error => {
        if (error.status == 401)
          this.sessionTimeOut();
        else
        this.handleError(errorCallBackFunc);
      });
    return getResult;
  }

  public  httpGetRequestObs$(url, errorCallBackFunc = '', showLoader = true) {
    var accessToken = UserInfo.AccessToken;
    var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
    if (showLoader == false) {
      headers = headers.set('ShowLoader', 'false');
    }
    return this.http.get(url, { headers: headers });
  }

  public httpODataGetRequest_Cached(url, errorCallBackFunc = '', showLoader = true) {
    if (this.Dic.has(url)) {
      let cahchedData = this.Dic.get(url);
      if (cahchedData.data) {
        // if `data` is available just return it as `Observable`
        return of(cahchedData.data);
      }
      else {
        return cahchedData.observable;
      }
    }
    else {
      let sharedUrlData = new SharedURLsData();
      this.Dic.set(url, sharedUrlData);
      // create the request, store the `Observable` for subsequent subscribers
      var accessToken = localStorage.getItem('ODataToken');
      var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
      headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
      if (showLoader == false) {
        headers = headers.set('ShowLoader', 'false');

      }
      sharedUrlData.observable = this.http.get(url, { headers: headers }).pipe(
        map(response => {
          // when the cached data is available we don't need the `Observable` reference anymore
          sharedUrlData.observable = null;
          sharedUrlData.data = response;
          return sharedUrlData.data;
        }
          // make it shared so more than one subscriber can get the result
        ), catchError(err => {
          this.Dic.delete(url);
          this.errorHandle(err);
          return throwError(err);
        }))
        .pipe(share());

      this.RequestsessionTimeOut(sharedUrlData.observable);
      return sharedUrlData.observable;
    }
  }


  public httpGetRequest_Cached(url, errorCallBackFunc = '', showLoader = true) {

    if (this.Dic.has(url)) {
      let cahchedData = this.Dic.get(url);
      if (cahchedData.data) {
        // if `data` is available just return it as `Observable`
        return of(cahchedData.data);
      }
      else {
        return cahchedData.observable;
      }
    }
    else {
      let sharedUrlData = new SharedURLsData();
      this.Dic.set(url, sharedUrlData);
      // create the request, store the `Observable` for subsequent subscribers
      var accessToken = UserInfo.AccessToken;
      var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
      headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
      if (showLoader == false) {
        headers = headers.set('ShowLoader', 'false');

      }
      sharedUrlData.observable = this.http.get(url, { headers: headers }).pipe(
        map(response => {
          // when the cached data is available we don't need the `Observable` reference anymore
          sharedUrlData.observable = null;
          sharedUrlData.data = response;
          return sharedUrlData.data;
        }
          // make it shared so more than one subscriber can get the result
        ), catchError(err => {
          this.Dic.delete(url);
          return throwError(err);
        }))
        .pipe(share());
      this.RequestsessionTimeOut(sharedUrlData.observable);
      return sharedUrlData.observable;
    }
  }
  public GetDataGenric<T>(url: string): Observable<T> {
    var accessToken = UserInfo.AccessToken;
    var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
    var apiResponse = this.http.get<T>(url, { headers: headers });
    this.RequestsessionTimeOut(apiResponse);
    return apiResponse;

  }

  public async httpGetRequest_subscribe(url, httpClient: HttpClient, errorCallBackFunc = '') {
    var accessToken = UserInfo.AccessToken;
    var headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    headers = headers.set('Accept-Language', this.lang.GetLanguageCode(UserInfo.Language));
    var Result;
    var getResult = await httpClient.get(url, { headers: headers });
    getResult.pipe(
      map(response => (<GridDataResult>{
        data: response["data"],
        total: parseInt(response["TotalCount"], 10)
      }))
    ).subscribe(x => super.next(x));
    await getResult.toPromise().then((result) => {
      Result = result;
    },
      error => {
        if (error.status == 401)
          this.sessionTimeOut();
        else
          this.handleError(errorCallBackFunc);
      });
    return Result;
  }


  public async httpPostRequest(url, body, errorCallBackFunc = '') {
    var accessToken = UserInfo.AccessToken;

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", `Bearer ${accessToken}`);
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Accept-Language", this.lang.GetLanguageCode(UserInfo.Language));
    var getResult;
    var ApiRequest = this.http.post(url, body ? JSON.stringify(body) : "", { headers: headers });
    await ApiRequest.toPromise().then((result) => {
      getResult = result;
    }, error => {
      if (error.status == 401)
        this.sessionTimeOut();
      else
        this.handleError(errorCallBackFunc);
    });
    return getResult;
  }
  public async httpODataPostRequest(url, body, errorCallBackFunc = '', SerializeRequestBody: boolean = true) {
    var accessToken = localStorage.getItem('ODataToken');
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", `Bearer ${accessToken}`);
    headers = headers.append("Prefer", "return=representation");
    if (SerializeRequestBody) {
      headers = headers.append("Content-Type", "application/json");
    } else {
      headers = headers.append("Content-Type", "text/json");
    }
    if (body == undefined || body == null) {
      var err = { message: "Thereisnochangesdone" };
      debugger;
      this.errorHandle(err);
    }
    else {
      if (body.IsUpdated == "true") {
        var getResult;
        delete body.IsUpdated;
        let bodyObj = {...body};
        delete bodyObj.RowIndex;
        body = bodyObj ? JSON.stringify(bodyObj) : "";
        let ApiRequest = this.http.put(url, body, { headers: headers });
        await ApiRequest.toPromise().then((result) => {
          getResult = { result: result, error: false };
        }, error => {
          if (error.status == 401)
            this.sessionTimeOut();
          else
            this.errorHandle(error);
          getResult = { result: null, error: true ,errorBody:error};
        });
        if (getResult == null) getResult = '';
        return getResult;
      }
      else {
        var getResult;

        delete body.IsUpdated;
        delete body.RowIndex;
        body = body ? JSON.stringify(body) : "";

        let ApiRequest = this.http.post(url, body, { headers: headers });
        await ApiRequest.toPromise().then((result) => {
          getResult = { result: result, error: false };
        }, error => {
          if (error.status == 401)
            this.sessionTimeOut();
          else
            this.errorHandle(error);
          getResult = { result: null, error: true,errorBody:error };
        });
        return getResult;
      }
    }
  }
  public async httpODataPutRequest(url, body, errorCallBackFunc = '') {
    var accessToken = localStorage.getItem('ODataToken');
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", `Bearer ${accessToken}`);
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Prefer", "return=representation");
    if (body == undefined || body == null) {
      var err = { message: "Thereisnochangesdone" };
      this.errorHandle(err);
    }
    else {
        var getResult;

        delete body.IsUpdated;
        delete body.RowIndex;
        delete body.rowguid;
        body = body ? JSON.stringify(body) : "";

        let ApiRequest = this.http.put(url, body, { headers: headers });
        await ApiRequest.toPromise().then((result) => {
          getResult = { result: result, error: false };
        }, error => {
          if (error.status == 401)
            this.sessionTimeOut();
          else if (error.status !== 200)
            this.errorHandle(error);
          getResult = { result: null, error: true };
        });
        return getResult;
    }
  }
  public async httpODatabatchRequest(url, body, errorCallBackFunc = '') {
    var accessToken = localStorage.getItem('ODataToken');
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", `Bearer ${accessToken}`);
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Accept", "*/*");
    headers = headers.append("Accept-Language", this.lang.GetLanguageCode(UserInfo.Language));
    //headers = headers.append("Accept-Encoding", "gzip, deflate, br");
    headers = headers.append("ccess-Control-Allow-Origin", "*");
    headers = headers.append("Access-Control-Allow-Headers", "Content-Type");
    headers = headers.append("Access-Control-Allow-Methods", "GET,POST,OPTIONS,DELETE,PUT");
    if (body == undefined || body == null || body['requests'].length==0) {
      var err = { message: "Thereisnochangesdone" };
      this.errorHandle(err);
    }
    else {
      var getResult;
      let ApiRequest = this.http.post(url, body, { headers: headers });
      await ApiRequest.toPromise().then((result) => {

        getResult = { result: result, error: false };
      }, error => {
        if (error.status == 401)
          this.sessionTimeOut();
        else
          this.errorHandle(error);
        getResult = { result: null, error: true };
      });
      return getResult;
    }
  }
  public async httpODataDeleteRequest(url, errorCallBackFunc = '') {
    var accessToken = localStorage.getItem('ODataToken');
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", `Bearer ${accessToken}`);
    headers = headers.append("Content-Type", "application/json");
    var getResult;
    var ApiRequest = this.http.delete(url, { headers: headers });
    await ApiRequest.toPromise().then((result) => {
      getResult = { result: result, error: false };
    }, error => {
      if (error.status == 401)
        this.sessionTimeOut();
      else
        this.errorHandle(error);
      getResult = { result: null, error: true };
    });

    return getResult;
  }

  public async httpPostRequestUnAuthorized(url, body, errorCallBackFunc = '') {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    var getResult;
    await this.http.post(url, body ? JSON.stringify(body) : "", { headers: headers })
      .toPromise().then((result) => {
        getResult = result;
      }, error => {
        if (error.status == 401)
          this.sessionTimeOut();
        else
        this.handleError(errorCallBackFunc);
      });
    return getResult;
  }

  public async httpPostDataUnAuthorized(url, body, errorCallBackFunc = '') {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    var getResult;
    return await this.http.post(url, body ? JSON.stringify(body) : "", { headers: headers });
  }

  public handleError(errorCallBackFunc) {
    if (errorCallBackFunc && errorCallBackFunc != '')
      eval(errorCallBackFunc);
  }
  // Error handling
  errorHandle(error) {
    const errValidationConfirm = error?.error?.error?.message?.value;
    if (errValidationConfirm && errValidationConfirm[errValidationConfirm?.length - 1] !== "?") {
      let errorMessage = '';
      let InnerException = '';
      if (!error.error || error.error == null || error.error == undefined)
        this.openErrorConfirmationDialog(error.message, null);
      else if (!error.error.error || error.error.error == null || error.error.error == undefined)
        this.openErrorConfirmationDialog(error.title, null);
      else if (error.error instanceof ErrorEvent) {
        // Get client-side error
        if (error.error.error.hasOwnProperty("Message"))
          errorMessage = error.error.error.Message.value;
        else if (error.error.error.hasOwnProperty("message"))
          errorMessage = error.error.error.message.value;
        this.error(errorMessage);

      } else {
        // Get server-side error
        if (error.error.error.hasOwnProperty("Message"))
          errorMessage = `${error.error.error.Message.value}`;
        else if (error.error.error.hasOwnProperty("message"))
          errorMessage = `${error.error.error.message.value}`;
        if (error.error.innerError && error.error.innerError.trace) {
          InnerException = error.error.innerError.trace;
        }
        this.openErrorConfirmationDialog(errorMessage, InnerException);
      }
      return throwError(errorMessage);
    }
    else {
      this.openErrorConfirmationDialog(error.message, null);
    }
  }

  public async ping(url: string) {
    var getResult = true;
    var ApiRequest = this.http.get(url);
    await ApiRequest.toPromise().then((result) => {
      getResult = true;
    },
      error => {
        getResult = false;
      });
    this.RequestsessionTimeOut(ApiRequest);
    return getResult;
  }

  async error(error: string) {
    this.toastr.error(this.getName(error), null, { closeButton: true, disableTimeOut: true });
  }
  openErrorConfirmationDialog(errorMessage: string, InnerException: string) {
    var ErrorDetails = "Error Details";
    if (UserInfo.Language == 1)
      ErrorDetails = "عرض التفاصيل";
    let innerExceptionHtml = `
  <a class="btn btn-primary mt-1" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
   `+ ErrorDetails +
      `</a>` + `
<div class="collapse" id="collapseExample">
  <div class="card card-body">`+
      InnerException + `
  </div>
</div> `;
    if (InnerException == '' || InnerException == null || InnerException == undefined) {
      innerExceptionHtml = '';
    }
    Swal.fire({
      html: `<div>${this.translate.instant("error")}</div><div style=font-size:15px>${this.translate.instant(errorMessage) + innerExceptionHtml}</div>`,
      showCloseButton: true,
      background: '#fff url(assets/images/block_black_24dp.svg) center center no-repeat',
      showConfirmButton: false
    });
  }
  public getName(key: string): string {
    return this.lang.GetName(key);
  }
}
